module.exports = __webpack_public_path__ + "img/omics-harbour-logo.dc0473bf.png";